export const productionHandoverStatusLabels = {
  AVAILABLE: 'Dostępne',
  REQUESTED: 'Oczekuje na analizę',
  PROCESSING: 'Analiza w toku',
  DATA_COLLECTED: 'Oczekuje na finalizację',
  COMPLETED: 'Zgodne',
  DISCREPANCY: 'Niezgodność',
  FAILED: 'Błąd',
  CLOSED_WITH_DISCREPANCY: 'Zamknięte z niezgodnością',
};

export const productionHandoverEventLabels = {
  CREATED: 'Utworzono zlecenie',
  IMPORTED: 'Zaimportowano zlecenie',
  REQUESTED: 'Zlecono analizę',
  PROCESSING_STARTED: 'Bot rozpoczął analizę',
  DATA_COLLECTED: 'Zebrano dane',
  FINALIZED_COMPLETED: 'Analiza zakończona jako zgodna',
  FINALIZED_DISCREPANCY: 'Wykryto niezgodność',
  FAILED: 'Wystąpił błąd',
  RETRIED_AFTER_FAILURE: 'Ponowiono analizę po błędzie',
  REVIEW_RETRY_REQUESTED: 'Wyjaśniono problem i ponowiono analizę',
  CLOSED_WITH_DISCREPANCY: 'Zamknięto z niezgodnością',
  STALE_PROCESSING_RECOVERED: 'Odzyskano zawieszone przetwarzanie',
};

export const productionHandoverIssueLabels = {
  SAP_CONFIRMATION_MISSING: 'Brak potwierdzenia SAP',

  NO_EWM_TASK: 'Brak zadania w EWM',

  EWM_IN_PROCESS: 'HU w trakcie realizacji',

  EWM_OPEN: 'Otwarte zadanie EWM',

  EWM_CANCELLED: 'Anulowane zadanie EWM',

  QUANTITY_MISMATCH: 'Różnica ilości',

  EXTRA_EWM_HU: 'Dodatkowe HU w EWM',

  UNKNOWN: 'Nieznany problem',
};
